@if(step === 3){
<!-- Start::resumen de paso 2 -->
@if(cartSession?.shipment?.deliveryMode === 'pickup' && store){
<div class="mb-6">
  <div
    class="border-bottom-1 pb-3 surface-border flex justify-content-between"
  >
    <span class="text-900 text-lg"
      ><b class="text-xl">Información de entrega</b></span
    >
  </div>
  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold">{{ store.name }}</span>
    <span class="text-600 text-sm mb-1 uppercase">
      {{ store.address }}
    </span>
  </div>

  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold">RETIRA EN TIENDA</span>
    <span class="text-600 text-sm mb-1">
      {{
        cartSession?.observation == 'Persona que recibe: Titular de la Venta'
          ? 'Titular de la compra'
          : (cartSession?.observation || 'Recibe: Titular de la Venta')
              .split('Celular')[0]
              .split('Recibe:')[1]
      }}
    </span>
  </div>
  @for(item of cartSession?.groups; track $index){
  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold"
      >FECHA DE ENTREGA @if((cartSession?.groups?.length || 0) > 1){
      {{ $index + 1 }}/{{ cartSession?.groups?.length }}
      }
    </span>
    <span class="text-600 text-sm mb-1 capitalize-first-letter"
      >{{ item.shipment.requestedDate | shippingDate }}
    </span>
  </div>
  }
</div>
} @else if(cartSession?.shipment?.deliveryMode === 'delivery' &&
direccionDespacho) {
<div class="mb-6">
  <div
    class="border-bottom-1 pb-3 surface-border flex justify-content-between"
  >
    <span class="text-900 text-lg"
      ><b class="text-xl">Información de entrega</b></span
    >
  </div>
  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold">DIRECCIÓN</span>
    <span class="text-600 text-sm mb-1 uppercase">
      {{ direccionDespacho.address }}
    </span>
  </div>

  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold">DESPACHO A DOMICILIO</span>
    <span class="text-600 text-sm mb-1">
      {{
        cartSession?.observation == 'Persona que recibe: Titular de la Venta'
          ? 'Titular de la compra'
          : (cartSession?.observation || 'Recibe: Titular de la Venta')
              .split('Celular')[0]
              .split('Recibe:')[1]
      }}
    </span>
  </div>

  @for(item of cartSession?.groups; track $index){
  <div class="flex flex-column py-2 border-bottom-1 surface-border">
    <span class="text-900 font-semibold"
      >FECHA DE ENTREGA @if((cartSession?.groups?.length || 0) > 1){
      {{ $index + 1 }}/{{ cartSession?.groups?.length }}
      }
    </span>
    <span class="text-600 text-sm mb-1 capitalize-first-letter"
      >{{ item.shipment.requestedDate | shippingDate }}
    </span>
  </div>
  }
</div>
} }

<!-- Start::productos disponibles -->
@if(productsAvailable.length){
<div
  class="border-bottom-1 pb-3 surface-border flex justify-content-between align-items-end"
>
  <span class="text-900 text-lg"
    ><b class="text-xl">Resumen de compra</b> ({{ productsAvailable.length }}
    {{ productsAvailable.length === 1 ? 'producto' : 'productos' }})</span
  >
  <a
    routerLink="/carro-compra/resumen"
    class="text-primary underline font-bold link cursor-pointer"
    >Editar</a
  >
</div>
@for(product of productsAvailable; track $index){
<a
  class="flex flex-column lg:flex-row lg:align-9-center py-2 mt-3 border-bottom-1 surface-border gap-3"
  [routerLink]="root.product(product.sku, product.name)"
>
  <div class="image-container">
    <img
      [src]="product.images?.['150']?.[0]"
      [alt]="product.name"
      class="w-3rem sm:w-4rem flex-shrink-0 border-round border-1 surface-border hover:border-400"
    />
    <span class="product-quantity">{{ product.quantity }}</span>
  </div>

  <div class="flex flex-column">
    <span class="text-900 font-semibold">{{ product.name }}</span>
    <span>{{ product.price | currency }} por unidad</span>
  </div>
  <span class="text-900 font-bold ml-auto"
    >{{ product.price * product.quantity | currency }}
  </span>
</a>
} }
<!-- End::productos disponibles -->

<!-- Start::productos no disponibles -->
@if(productsUnavailable.length){
<div
  class="border-bottom-1 pb-3 surface-border flex justify-content-between align-items-end mt-5"
>
  <span class="text-900 text-lg"
    ><b class="text-xl">Productos no disponibles</b> ({{
      productsUnavailable.length
    }}
    {{ productsUnavailable.length === 1 ? 'producto' : 'productos' }})</span
  >
</div>
@for(product of productsUnavailable; track $index){
<a
  class="flex flex-column lg:flex-row flex-wrap lg:align-9-center py-2 mt-3 border-bottom-1 surface-border gap-3"
  [routerLink]="root.product(product.sku, product.name)"
>
  <div class="image-container">
    <img
      [src]="product.images?.['150']?.[0]"
      [alt]="product.name"
      class="w-3rem sm:w-4rem flex-shrink-0 border-round border-1 surface-border unavailble-product"
    />
    <span class="product-quantity">{{ product.quantity }}</span>
  </div>

  <div class="flex flex-column">
    <span class="text-400 font-semibold">{{ product.name }}</span>
    <div class="text-red-600 text-sm flex gap-2 align-items-center">
      <i class="fa-solid fa-circle-exclamation"></i>
      <span>La cantidad seleccionada no está disponible</span>
    </div>
  </div>
</a>
} }
<!-- End::productos no disponibles -->

<!-- Start::totales -->
<div class="py-2 mt-3">
  <div class="flex justify-content-between align-items-center mb-2">
    <span class="text-900 font-medium">Subtotal</span>
    <span class="text-900">{{
      cartService.subtotal$ | async | currency
    }}</span>
  </div>
  <!-- si es paso 1 filtrar y quitar los que tenga type: 'shipping' -->
  @for(item of cartService.totals$|async; track $index ){ @if(item.type !==
  'shipping' || step >=2 ){
  <div class="flex justify-content-between align-items-center mb-2">
    <span
      [ngClass]="{ 'text-red-600': item.title == 'Descuento Despacho' }"
      class="text-900 font-medium"
      >{{ item.title }}</span
    >
    <span
      [ngClass]="{ 'text-red-600': item.title == 'Descuento Despacho' }"
      class="text-900"
      >{{ item.price | currency }}</span
    >
  </div>
  } }

  <div class="flex justify-content-between align-items-center mb-3">
    <span class="text-900 font-bold text-lg">Total a pagar</span>
    <span class="text-900 font-bold text-lg">
      {{ cartService.total$ | async | currency }}</span
    >
  </div>
</div>
<!-- End::totales -->
